import {
  generateCaptcha, checkCaptcha, submitCaptcha, delCaptcha
} from "@/api/captcha";

export default {
  namespaced: true,
  actions: {
    async generateCaptcha(context, params) {
      const data = await generateCaptcha(params);
      return data;
    },

    async checkCaptcha(context, params) {
      const res = await checkCaptcha(params);
      return res;
    },

    async submitCaptcha(context, params) {
      const res = await submitCaptcha(params);
      return res;
    },

    async delCaptcha(context, params) {
      const res = await delCaptcha(params);
      return res;
    }
  }
};
